import { Box, Image, SimpleGrid, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import imgContent01 from "../../../assets/images/content/bg/content-sslo-01.png";
import imgContent02 from "../../../assets/images/content/bg/content-sslo-02.png";
import tContent01 from "../../../assets/images/content/bg/content-tablet-sslo-01.png";
import tContent02 from "../../../assets/images/content/bg/content-tablet-sslo-02.png";
import mContent01 from "../../../assets/images/content/bg/content-tablet-sslo-01.png";
import mContent02 from "../../../assets/images/content/bg/content-tablet-sslo-02.png";

import styled from "styled-components";
import { AutoLabelingContentList, DataUsedExampleList } from "../../../assets/datas/ConstantLists";
import { useContext, useEffect, useState } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";
import { convertFontSize } from "../../../components/Util";

const SSLOWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ItemBox = styled.div`
  position: relative;
  border-radius: 27px;
  width: 100%;
  height: 100%;
  cursor: pointer;

  @media (max-width: 768px) {
    min-width: 30vw;
    margin-right: 10%;
    &:last-child {
      margin: 0;
    }
  }
`;

const ScrollBox = styled.div`
&::-webkit-scrollbar {
  display: none;
}
  width: calc(100vw - 10%);
  display: flex;
  overflow-x: scroll;
`;

const BtnSSLO = styled.button`
  width: 300px;
  height: 60px;
  background: #333333;
  color: #ffffff;
  font-size: 18px;
  border-radius: 62px;
  margin-bottom: 100px;
  &:hover {
    background: #969696;
  }
`;

const SSLO = () => {
  const screen = useContext(ScreenContext).style;
  const contents = [
    {
      pc: imgContent01,
      mobile: mContent01,
      tablet: tContent01,
    },
    {
      pc: imgContent02,
      mobile: mContent02,
      tablet: tContent02,
    },
  ];

  const [isHover, setIsHover] = useState<boolean[]>([]);

  const onMouseEnter = (index: number) => {
    setIsHover(isHover.map((h, id) => { return id === index; }));
  };

  const onMouseMove = (index: number) => {
    setIsHover(isHover.map((h, id) => { return id === index; }));
  };

  const onMouseLeave = () => {
    setIsHover(isHover.map(() => { return false; }));
  };

  useEffect(() => {
    if(!DataUsedExampleList) return;
    const list = [];
    DataUsedExampleList.forEach(() => {
      list.push(false);
    });
    setIsHover(list);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [DataUsedExampleList]);

  return (
    <SSLOWrapper>
      <Image src={contents[0][screen]} w={"100%"} alt="" />
      <Box w={"100%"} p={"0 5%"}>
        <Tabs defaultIndex={0} isFitted colorScheme="tBlack">
          <TabList color={"#333333"} mb={"30px"}>
            <Tab borderColor={"#D9D9D9"} fontWeight={700}>HD</Tab>
            <Tab borderColor={"#D9D9D9"} fontWeight={700}>OD</Tab>
            <Tab borderColor={"#D9D9D9"} fontWeight={700}>IS</Tab>
            <Tab borderColor={"#D9D9D9"} fontWeight={700}>SES</Tab>
          </TabList>
          {/* <TabIndicator
            mt="-1.5px"
            height="2px"
            bg="tBlack.500"
            borderRadius="1px"
          /> */}

          <TabPanels>
            {AutoLabelingContentList.map((item, index) => {
              return (
                <TabPanel key={index} h={screen === "mobile" ? "fit-content" : "30vw"} display={"flex"} flexDir={screen === "mobile" ? "column" : "row"}>
                  <Image src={item.image} w={screen === "mobile" ? "100%" : "50%"} h={"auto"} objectFit={"contain"} alt="" mb={screen === "mobile" ? "50px" : "0"} />
                  <Box 
                    display={"flex"} 
                    flexDir={"column"} 
                    alignItems={"center"} 
                    w={screen === "mobile" ? "100%" : "50%"}
                    h={"100%"}
                    justifyContent={"center"}
                    lineHeight={1.5}
                  >
                    <Text color={"#121212"} fontSize={"20px"} fontWeight={700}>{item.type}</Text>
                    <Text color={"#121212"} fontSize={"20px"} fontWeight={700}>{item.title}</Text>
                    <Text color={"#121212"} whiteSpace={"pre-wrap"} textAlign={"center"} fontWeight={300}>{item.desc}</Text>
                  </Box>
                </TabPanel>
              )
            })}
          </TabPanels>
        </Tabs>
      </Box>
      <Image src={contents[1][screen]} w={"100%"} alt="" />
      <Box w={"100%"} p={"5%"} mb={screen === "mobile" ? "50px" : "100px"}>
      {screen !== "mobile" ? 
        <SimpleGrid columns={5} gap={7}>
          {DataUsedExampleList?.map((item, index) => {
            return (
              <ItemBox 
                key={index} 
                onMouseEnter={() => onMouseEnter(index)} 
                onMouseMove={() => onMouseMove(index)} 
                onMouseLeave={onMouseLeave}
              >
                <Image src={item.image} w={"100%"} h={"100%"} alt="" />
                <Box 
                  position={"absolute"} 
                  w={"100%"} 
                  h={"100%"} 
                  left={0}
                  top={0}
                  p={isHover[index] ? "20% 2%" : "10% 2%"} 
                  display={"flex"} 
                  flexDirection={"column"}
                  justifyContent={isHover[index] ? "space-between" : "center"}
                  alignItems={"center"}
                >
                  <Text fontSize={convertFontSize(22, 36)} fontWeight={600}>{item.title}</Text>
                  {isHover[index] && 
                    <Text 
                      whiteSpace={"pre-wrap"} 
                      fontSize={convertFontSize(12, 20)} 
                      textAlign={"center"}
                      lineHeight={1.5}
                      mb={"10%"}
                    >
                      {screen === "pc" ? item.contents : item.contents.replace(" 사물 음성", `\n사물 음성`)}
                    </Text>
                  }
                </Box>
              </ItemBox>
            )
          })}
        </SimpleGrid>
      :
        <ScrollBox>
          {DataUsedExampleList?.map((item, index) => {
            return (
              <ItemBox 
                key={index} 
                onMouseEnter={() => onMouseEnter(index)} 
                onMouseMove={() => onMouseMove(index)} 
                onMouseLeave={onMouseLeave}
              >
                <Image src={item.image} w={"100%"} h={"100%"} alt="" />
                <Box 
                  position={"absolute"} 
                  w={"100%"} 
                  h={"100%"} 
                  left={0}
                  top={0}
                  p={isHover[index] ? "20% 2%" : "10% 2%"} 
                  display={"flex"} 
                  flexDirection={"column"}
                  justifyContent={isHover[index] ? "space-between" : "center"}
                  alignItems={"center"}
                >
                  <Text fontSize={convertFontSize(20, 24)} fontWeight={600}>{item.title}</Text>
                  {isHover[index] && 
                    <Text 
                      whiteSpace={"pre-wrap"} 
                      fontSize={convertFontSize(10, 14)} 
                      textAlign={"center"}
                      lineHeight={1.5}
                      mb={"10%"}
                    >
                      {item.contents.replace(" 사물 음성", `\n사물 음성`)}
                    </Text>
                  }
                </Box>
              </ItemBox>
            )
          })}
        </ScrollBox>
      }
      </Box>
      <BtnSSLO onClick={() => window.open("http://sslo.ai/", '_blank')}>S.S.L.O 체험하기</BtnSSLO>
    </SSLOWrapper>
  );
};

export default SSLO;